export function removeEmpty<T = Object>(obj): T {
  return Object.entries(obj)
    .filter(([_, v]) => v != null)
    .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {}) as T;
}
